



























import Vue from 'vue'
import GHeaderDefaultContent from '@/components/globals/GHeader/GHeaderDefaultContent.vue'
import GHeaderTitledContent from '@/components/globals/GHeader/GHeaderTitledContent.vue'

export default Vue.extend({
  components: {
    GHeaderDefaultContent,
    GHeaderTitledContent,
  },
  props: {
    title: {
      type: String as () => string,
      default: '',
    },
    hideSpTitle: {
      type: Boolean,
      default: false,
    },
    hideSpSearch: {
      type: Boolean,
      default: false,
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isTitledHeader(): boolean {
      return this.title !== '' && !this.hideSpTitle
    },
    hasRightButton(): boolean {
      return Boolean(this.$slots.rightButton)
    },
  },
})
